import { INGXLoggerMonitor } from "ngx-logger";
import {
  getLogLevelDisplayName,
  writeToConsole,
} from "app/shared/helpers/logger-monitor-utils";

// Used to improve the readability of console logs in reports and environments without JS map files.
// This monitor hooks into NGXLogger and renders all logs to the console.
// Log messages in plain text as follows: <timestamp> <log-level> <message>
export class LoggerMonitorMinimal implements INGXLoggerMonitor {
  public onLog(log: any): void {
    // Preparing data:
    const timestamp: string = LoggerMonitorMinimal.getTimestamp(new Date());
    const logLevelDisplayName: string = getLogLevelDisplayName(log.level);

    writeToConsole(log, `${timestamp} ${logLevelDisplayName} ${log.message}`);
  }

  private static getTimestamp(date: Date): string {
    const hours: string = date.getHours().toString().padStart(2, "0");
    const minutes: string = date.getMinutes().toString().padStart(2, "0");
    const seconds: string = date.getSeconds().toString().padStart(2, "0");
    const milliseconds: string = date
      .getMilliseconds()
      .toString()
      .padStart(3, "0");

    return `${hours}:${minutes}:${seconds}.${milliseconds}`;
  }
}
